<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import VueToastedUtils from '@/utils/vue-toasted.utils.js'

export default {
  data() {
    return {
      currentToast: null,
    }
  },

  computed: {
    ...mapGetters('aiChatbotImportPptxPdf', ['canUseAIChatbotImportPptxPdf']),
  },

  mounted() {
    EventBus.$on('import-convert-io: close_importing_toast', () => {
      if (this.currentToast) {
        this.currentToast.goAway(0)
      }
    })
    this.currentToast = VueToastedUtils.showToast(this.$i18nPresenter.t('Importing presentation…'), {}, {
      className: 'custom-toast__loading',
      hasReturnValue: true,
      action: this.canUseAIChatbotImportPptxPdf ? {} : {
        text: this.$i18nPresenter.t('View'),
        class: 'custom-toast__loading-url',
        onClick: () => {
          if (this.$store.state.openImportModal) return
          this.$store.state.openImportModal = true
        },
      },
    })
  },

  destroyed() {
    EventBus.$off('import-convert-io: close_importing_toast')
  },
}
</script>

<style>
.custom-toast__loading.toasted.bubble {
  color: #621BAF;
  background-color: #F2F7FF !important;
  border: 1px solid #6A1EBB;
  border-radius: 4px;
  &::before {
    content: "";
    animation: spin 1s linear infinite;
    display: inline-block;
    border-radius: 100%;
    height: 1rem;
    width: 1rem;
    border: 2px solid rgba(106, 30, 187, 0.3);
    border-top-color: #6A1EBB;
    margin-right: 0.5rem;
  }
  & .action.toast-action-text {
    color: #621BAF !important;
  }
  & .custom-toast__loading-url {
    color: #621BAF;
    font-weight: normal;
    text-transform: capitalize;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
